import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

/**
 * Handles the magic-link return URL (`/auth/callback`).
 * Supabase JS parses the URL (PKCE code or tokens); we wait for a session, then route in.
 */
export function AuthCallbackPage() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!supabase) {
      setFailed(true);
      return;
    }

    const client = supabase;
    let cancelled = false;

    const finish = async () => {
      const { data, error } = await client.auth.getSession();
      if (cancelled) return;

      if (error || !data.session) {
        setFailed(true);
        return;
      }

      navigate('/', { replace: true });
    };

    void finish();

    const { data: sub } = client.auth.onAuthStateChange((event, session) => {
      if (cancelled) return;
      if (session && (event === 'SIGNED_IN' || event === 'INITIAL_SESSION')) {
        navigate('/', { replace: true });
      }
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  if (!supabase || failed) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center px-6 text-sm text-[#12141a]/60"
      style={{ backgroundColor: '#F7F5F2' }}
    >
      {t('callback.signingIn')}
    </div>
  );
}
